import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { SLICE_NAMESPACE } from '../../constants';
import { INavigationState } from '../../types';

export const fetchCategories = createAppAsyncThunk(`${SLICE_NAMESPACE}/fetchCategories`, async () =>
  apiService.masterEntities.getCategoryList(),
);

export const fetchCategoriesReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(fetchCategories.pending, state => {
      state.options.categories.loading = true;
      state.options.categories.list = [];
    })
    .addCase(fetchCategories.rejected, state => {
      state.options.categories.loading = false;
      state.options.categories.list = [];
    })
    .addCase(fetchCategories.fulfilled, (state, action) => {
      state.options.categories.loading = false;
      state.options.categories.list = action.payload;
    });
